#import "~/graphql/fragments/Components/CraftLink.graphql"

fragment RestaurantHero on restaurantHero_MatrixField {
    ... on restaurantHeroBlock_Entry {
        images {
            id
            url
            alt
            title
            width
            height
            w113: url @transform(width: 113, format: "webp", mode: "crop")
            w226: url @transform(width: 226, format: "webp", mode: "crop")
            w314: url @transform(width: 314, format: "webp", mode: "crop") # motog4/pagespeed DPR 3.0 image
            w418: url @transform(width: 418  format: "webp", mode: "crop")
            w113_avif: url @transform(width: 113, format: "avif", mode: "crop")
            w226_avif: url @transform(width: 226, format: "avif", mode: "crop")
            w314_avif: url @transform(width: 314, format: "avif", mode: "crop") # motog4/pagespeed DPR 3.0 image
            w418_avif: url @transform(width: 418, format: "avif", mode: "crop")
        }

        restaurantLogo {
            id
            url
            width
            height
            alt
            title
        }

        description
        callToActionText
        secondaryButtonLink {
            ...CraftLinkField
        }
        backgroundColor
        textColor
    }
}
